import { useQuery } from "react-query";
import URL from "core/resources/urls";
import http from "infra/http";

function useGetOperacoes(centroCustoIdExterno?: string) {
  return useQuery(
    [URL.PLANO_OPERACIONAL.OBTER_OPERACAO_DROPDOWN_ID_EXTERNO, centroCustoIdExterno],
    async () => {
      const { data } = await http.get(URL.PLANO_OPERACIONAL.OBTER_OPERACAO_DROPDOWN_ID_EXTERNO, {
        params: { centroCustoIdExterno },
      });
      return data;
    },
    {
      enabled: !!centroCustoIdExterno,
    },
  );
}

export default useGetOperacoes;
